import gql from "graphql-tag";

const RUNNER_SHIFT_FIELDS = gql`
  fragment RunnerShiftFields on RunnerShift {
    id
    installationId
    name
    description
    startTime
    endTime
    gracePeriodMinutes
    maxCollectPerSlot
    maxParkPerSlot
    slotMinutes
    isActive
  }
`;

export const runnerShiftsQuery = gql`
  query RunnerShifts($installationId: ID!, $includeInactive: Boolean) {
    runnerShifts(installationId: $installationId, includeInactive: $includeInactive) {
      ...RunnerShiftFields
    }
  }
  ${RUNNER_SHIFT_FIELDS}
`;

export const createRunnerShiftMutation = gql`
  mutation CreateRunnerShift($shift: RunnerShiftCreateInput!) {
    createRunnerShift(shift: $shift) {
      ...RunnerShiftFields
    }
  }
  ${RUNNER_SHIFT_FIELDS}
`;

export const updateRunnerShiftMutation = gql`
  mutation UpdateRunnerShift($shift: RunnerShiftUpdateInput!) {
    updateRunnerShift(shift: $shift) {
      ...RunnerShiftFields
    }
  }
  ${RUNNER_SHIFT_FIELDS}
`;

export const deleteRunnerShiftMutation = gql`
  mutation DeleteRunnerShift($id: ID!) {
    deleteRunnerShift(id: $id)
  }
`;
